export const PO_ITEMS_TAB_ID = "PO-Items";
export const PO_APPROVERS_TAB_ID = "PO-Approvers";
export const PO_ATTACHMENTS_TAB_ID = "PO-Attachments";
export const PO_COMMENTS_TAB_ID = "PO-Comments";
